import { observer } from 'mobx-react';
import React from 'react';
import z from 'z';

@observer
class NoUser extends React.Component {
  render() {
    const TM3 = z.word('TM3');
    return (
      <div>
        <h4>Your user account has not been setup</h4>
        <p>
          You have successfully signed in with {TM3} integrated login, however, your user account
          has not yet been setup in {TM3}.
        </p>
        <p>Please contact your IT Support Team to set you up.</p>
        <a href="/login">Click here to try again</a>
      </div>
    );
  }
}

export default NoUser;
